export const errorTypes = {
  inline: 'inline-error',
  global: 'global-error'
}

export function validationError(sourceId, label, section, errorNum, message, errorType = errorTypes.global) {
  const errorId = section + '-' + errorNum;
  return {
    id: "error-" + sourceId + "-" + errorId,
    sourceId,
    type: errorType,
    context: label,
    errorMessage: message
  };
};

export function sectionedValidationError(sourceId, label, subSection, section, errorNum, message, errorType = errorTypes.global) {
  var baseError = validationError(sourceId, label, section, errorNum, message, errorType);
  return {
    subSection,
    ...baseError
  };
}
